import photo11 from "../../images/01.jpg";
import photo12 from "../../images/02.jpg";
import photo13 from "../../images/03.jpg";

const Data =[{
    image : photo11,
    Title :" Rainbow Vegetable Sandwich",
    text : "Time: 15 - 20 Minutes | Serves:",
    price : "$10.50",
    offer : "$11.70"
},
{
    image : photo12,
    Title :" Vegetarian Burger",
    text : "Time: 30 - 45 Minutes | Serves: 1",
    price : "$9.50",
    offer : "$10.70"
},
{
    image : photo13,
    Title :" Raspberry Stuffed French Toast",
    text : "Time: 10 - 15 Minutes | Serves: 1",
    price : "$12.50",
    offer : "$13.70"
}]
export default Data ;